/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFriendsSetStatusRequest interface.
 */
export function instanceOfFxIdWebFeaturesFriendsSetStatusRequest(value) {
    if (!('Status' in value) || value['Status'] === undefined)
        return false;
    if (!('Priority' in value) || value['Priority'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFriendsSetStatusRequestFromJSON(json) {
    return FxIdWebFeaturesFriendsSetStatusRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSetStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Name': json['Name'] == null ? undefined : json['Name'],
        'Status': json['Status'],
        'Priority': json['Priority'],
    };
}
export function FxIdWebFeaturesFriendsSetStatusRequestToJSON(json) {
    return FxIdWebFeaturesFriendsSetStatusRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSetStatusRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Name': value['Name'],
        'Status': value['Status'],
        'Priority': value['Priority'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFriendsSetStatusRequest.js.map